import { Form, Input, Modal, Select } from "antd";
import { Currency, SupplierType } from "../../enum/common";
import { useCreateSupplier } from "../../query/PurchaseQuery";
import { notify } from "../../utils/toast";

interface IModalAddSupplierProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const ModalAddSupplier = ({
  open,
  onCancel,
  onSuccess,
}: IModalAddSupplierProps) => {
  const [form] = Form.useForm();
  const createSupplier = useCreateSupplier();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await createSupplier.mutateAsync(values);
      notify.success("Thêm nhà cung cấp thành công");
      form.resetFields();
      onSuccess();
    } catch (error) {
      notify.error("Thêm nhà cung cấp thất bại");
    }
  };

  return (
    <Modal
      title="Thêm nhà cung cấp"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={createSupplier.isPending}
      okText="Thêm"
      cancelText="Hủy"
      width={600}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Tên nhà cung cấp"
          name="name"
          rules={[
            { required: true, message: "Vui lòng nhập tên nhà cung cấp" },
          ]}
        >
          <Input placeholder="Nhập tên nhà cung cấp" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Vui lòng nhập email" },
            { type: "email", message: "Email không hợp lệ" },
          ]}
        >
          <Input placeholder="Nhập email" />
        </Form.Item>

        <Form.Item
          label="Loại nhà cung cấp"
          name="type"
          rules={[{ required: true, message: "Vui lòng chọn loại" }]}
        >
          <Select placeholder="Chọn loại nhà cung cấp">
            <Select.Option value={SupplierType.LOCAL}>Nội địa</Select.Option>
            <Select.Option value={SupplierType.ONLINE}>
              Trực tuyến
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Quốc gia"
          name="country"
          rules={[{ required: true, message: "Vui lòng nhập quốc gia" }]}
        >
          <Input placeholder="Nhập quốc gia" />
        </Form.Item>

        <Form.Item
          label="Tiền tệ"
          name="currency"
          rules={[{ required: true, message: "Vui lòng chọn tiền tệ" }]}
        >
          <Select placeholder="Chọn tiền tệ">
            <Select.Option value={Currency.VND}>VND</Select.Option>
            <Select.Option value={Currency.USD}>USD</Select.Option>
            <Select.Option value={Currency.EUR}>EUR</Select.Option>
            <Select.Option value={Currency.CNY}>CNY</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddSupplier;
